import { plainDate } from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { forecastFrequency } from "./get-sku-sales-forecast";

const OnHandDataPoint_ = z.object({
  date: plainDate(),
  onHandQuantity: z.number().nullable(),
  // Forecast fields for future units on hand
  prediction: z.number().nullable(),
  lowerBound: z.number().nullable(),
  upperBound: z.number().nullable(),
  incomingShipmentUnits: z.number().nullable(),
});

export const OnHandDataPoint: z.ZodType<OnHandDataPoint> = OnHandDataPoint_;
export interface OnHandDataPoint extends z.infer<typeof OnHandDataPoint_> {}

const GetSkuOnHandHistoryOutput_ = z.object({
  sku: z.string(),
  data: z.array(OnHandDataPoint),
});

export const GetSkuOnHandHistoryOutput: z.ZodType<GetSkuOnHandHistoryOutput> =
  GetSkuOnHandHistoryOutput_;
export interface GetSkuOnHandHistoryOutput
  extends z.infer<typeof GetSkuOnHandHistoryOutput_> {}

export const getSkuOnHandHistory = {
  name: "getSkuOnHandHistory" as const,
  input: z.object({
    sku: z.string(),
    startDate: plainDate(),
    endDate: plainDate(),
    frequency: createEnum(forecastFrequency).optional().default("day"),
  }),
  output: GetSkuOnHandHistoryOutput,
};
